module.exports = __webpack_public_path__ + "static/media/cravenlinestyle.82335cda.svg";